import React from 'react';
import { useSpring, animated } from '@react-spring/web';
import { mergeClassNames, useClientRect } from '../../../../utils';
import styles from './index.module.scss';

const OPACITY_FROM = 0.01;
const OPACITY_TO = 0.99;

export default function AccordionElement({
  children,
  onClick,
  isVisible,
  expandingElement,
  className = null,
  style = null,
}) {
  let [measuredRef, rect] = useClientRect();

  let motionProps = useSpring({
    height: `${isVisible ? rect?.height : 0}px`,
    opacity: isVisible ? OPACITY_TO : OPACITY_FROM,
    overflow: 'hidden',
  });

  return (
    <li className={mergeClassNames(styles.accordionElement, className)} style={style}>
      <button onClick={onClick} className={styles.listElement}>
        {children}
      </button>
      <animated.div style={motionProps}>
        <div ref={measuredRef}>{expandingElement}</div>
      </animated.div>
    </li>
  );
}
